import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';
import { langFromPath } from '../lib/lang';

// The URL is the source of truth for the content language (architecture §2), so
// the INITIAL language must come from the URL too. Starting at 'en' and letting
// LangLayout flip to zh during the first render loses the race: the
// languageChanged event fires before App-level components (Header/Footer) have
// mounted their useTranslation subscriptions, so on a fresh /zh/* load they
// stayed English until some unrelated re-render (T52 spot-verification find,
// pre-existing in prod). With the URL-correct initial language the first render
// is already right; LangLayout remains the sync for client-side navigation,
// which happens post-mount where every subscription is live.
const initialLng = typeof window !== 'undefined' ? langFromPath(window.location.pathname) : 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
